export enum ModuleDependencyType {
	CONTACT_KANBAN = 'CONTACT_KANBAN',
	CONTACT_TASK_REPORT = 'CONTACT_TASK_REPORT',
	JOB_TASK_REPORT = 'JOB_TASK_REPORT',
	JOB_CRITERIA_SURVEY = 'JOB_CRITERIA_SURVEY',
	JOB_COMPANY_SURVEY = 'JOB_COMPANY_SURVEY',
	JOB_DETAIL_SURVEY = 'JOB_DETAIL_SURVEY',
	JOB_DOCUMENTS_SURVEY = 'JOB_DOCUMENTS_SURVEY',
	PUSH_MODULE = 'PUSH_MODULE',
}
